import { MenuItem, Select, styled } from "@mui/material";

export const ClusterMenuItem = styled(MenuItem)(({ theme }) => ({
  display: "flex",
  paddingTop: theme.spacing(1.5625),
  paddingBottom: theme.spacing(1.5625),
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  alignItems: "center",
  gap: theme.spacing(0.625),
  alignSelf: "stretch",
  position: "relative",
  fontSize: theme.spacing(1.5375),
  lineHeight: theme.spacing(2.625),
  letterSpacing: "0.5px",
  fontWeight: 300,
  
  "&::before": {
    content: "\"\"",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "1px",
    backgroundColor: theme.customColors.border
  },
  
  "&:first-child::before": {
    backgroundColor: "transparent"
  },
  "&:first-child": {
    paddingTop: theme.spacing(1.5625)
  },
  "&.Mui-selected": {
    color: theme.customColors.systemSecondary01,
    background: "none",
    fontWeight: 700,
    "&:hover": {
      background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
      borderRadius: theme.spacing(1),
      "&::before": {
        backgroundColor: "transparent"
      }
    }
  },
  "&:hover": {
    background: `rgba(${theme.customColors.backgroundSecondaryHover})`,
    borderRadius: theme.spacing(1),
    // Nasconde la linea sopra l'item in hover
    "&::before": {
      backgroundColor: "transparent"
    },
    // Nasconde la linea sopra l'item successivo (= linea sotto l'item in hover)
    "+ li::before": {
      backgroundColor: "transparent"
    }
  }
}));

export const ClusterSelect = styled(Select)(({ theme }) => ({
  "&.MuiInputBase-root": {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5625),
    paddingBottom: theme.spacing(1.5625),
    fontSize: theme.spacing(1.5),
    fontWeight: 500,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: theme.spacing(1),
    flexGrow: 1,
    height: theme.spacing(4.375)
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.customColors.border
  },
  ".MuiSelect-select": {
    padding: 0,
    display: "flex",
    alignItems: "center"
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: theme.customColors.border,
    borderWidth: "1px",
    borderStyle: "solid"
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.customColors.border
  },
  ".MuiSelect-iconOpen": {
    transform: "rotate(180deg)"
  },
  ".MuiSelect-icon": {
    transition:"all .3s linear"
  },
  ".MuiMenu-list": {
    marginTop: theme.spacing(1)
  }
}));
